{
  "name": "tms-client",
  "version": "1.7.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.3",
    "@angular/cdk": "^21.0.2",
    "@angular/common": "^21.0.3",
    "@angular/compiler": "^21.0.3",
    "@angular/core": "^21.0.3",
    "@angular/forms": "^21.0.3",
    "@angular/material": "^21.0.2",
    "@angular/material-moment-adapter": "^21.0.2",
    "@angular/platform-browser": "^21.0.3",
    "@angular/platform-browser-dynamic": "^21.0.3",
    "@angular/router": "^21.0.3",
    "@ckeditor/ckeditor5-angular": "^9.1.0",
    "@ckeditor/ckeditor5-build-classic": "^44.3.0",
    "@ckeditor/ckeditor5-upload": "^45.2.1",
    "@ng-matero/extensions": "^21.0.0",
    "@ngneat/until-destroy": "^10.0.0",
    "angular-cc-library": "^3.5.0",
    "file-saver": "^2.0.5",
    "inputmask": "^5.0.9",
    "jspdf": "^3.0.1",
    "moment": "^2.30.1",
    "ng2-file-upload": "^9.0.0",
    "ngx-image-cropper": "^9.1.6",
    "ngx-infinite-scroll": "^20.0.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.3.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.2",
    "@angular/cli": "^21.0.2",
    "@angular/compiler-cli": "^21.0.3",
    "@angular/language-service": "^21.0.3",
    "@types/inputmask": "^5",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "^12.11.1",
    "baseline-browser-mapping": "^2.9.14",
    "codelyzer": "^6.0.0",
    "jasmine-core": "~3.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.1",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "protractor": "~7.0.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "typescript": "5.9.3"
  }
}
